import { FavoriteFilled } from '@agilelab/plugin-wb-platform';
import { CompoundEntityRef, Entity } from '@backstage/catalog-model';
import { useStarredEntity } from '@backstage/plugin-catalog-react';
import { IconButton } from '@material-ui/core';
import FavoriteBorder from '@material-ui/icons/StarBorder';
import { ComponentProps, FC } from 'react';
import { WbTooltip } from '../WbTooltip';

type FavoriteEntityButtonProps = ComponentProps<typeof IconButton> & {
  entity: Entity | CompoundEntityRef | string;
};

export const WbFavoriteEntityButton: FC<FavoriteEntityButtonProps> = ({
  entity,
  ...props
}) => {
  const { toggleStarredEntity, isStarredEntity } = useStarredEntity(entity);

  return (
    <WbTooltip
      title={isStarredEntity ? 'Remove from favorites' : 'Add to favorites'}
    >
      <IconButton
        size="small"
        aria-label="favorite"
        color="secondary"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          toggleStarredEntity();
        }}
        {...props}
      >
        {isStarredEntity ? <FavoriteFilled /> : <FavoriteBorder />}
      </IconButton>
    </WbTooltip>
  );
};
